<template>
	<div id="addAddress">
		<!--头部-->
		<mt-header :title="adtitle"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnback">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
		  <a href="javascript:void(0)" slot="right" >
		    <mt-button @click="toselectAddress">保存</mt-button>
		  </a>
 	    </mt-header>
 	    
 	    <!--收货人信息-->
 	    <div class="addAddressmain mt40">
 	    	<div>
		 		<mt-field label="收货人：" placeholder="姓名" class="border-bottom-line" v-model="name"></mt-field>
		 		<mt-field label="联系电话：" placeholder="请输入联系方式" type="number" class="border-bottom-line" v-model.number="phonenum"></mt-field>
		 	</div>
		 	<!--<p>{{addressids}}</p>-->
		 	<!--<p>{{addresslength}}</p>-->
 	    </div>
        <div class="page-content">
	      <mt-cell title="所在地区:" :value="areaString" is-link @click.native="handlerArea" class="border-bottom-line"></mt-cell>
	      <mt-cell title="街道:" :value="streetString" is-link @click.native="handlerStreet" class="border-bottom-line"></mt-cell>
	      <mt-popup v-model="areaVisible" class="area-class" position="bottom">
	        <mt-picker :slots="slots" @change="onValuesChange" :showToolbar="true" value-key="name">
		        <span class="float-left"  @click="hidearea">取消</span>
	            <span class="float-right" @click="comfirmarea">完成</span>
            </mt-picker>
	      </mt-popup>
	      <mt-popup v-model="streetVisible" class="area-class" position="bottom">
	        <mt-picker :slots="slotstree" @change="onStreeChange" :showToolbar="true" value-key="name">
		        <span class="float-left"  @click="hidestreet">取消</span>
	            <span class="float-right" @click="comfirmstreet">完成</span>
            </mt-picker>
	      </mt-popup>
	    </div>
		
		<!--详细地址框-->
		<div class="aAddresstextarea border-bottom-line">
			<textarea class="aAtextarea font-size8" placeholder="请填写详细地址，不少于5个字" v-model="detailedaddress"></textarea>
		</div>
		
		<!--选择默认-->
		<div class="mint-cell-wrapper mt8">
			<div class="mint-cell-title">
				<span class="mint-cell-text">设为默认</span> 		
		    </div>
		    <div class="mint-cell-value">
		    	<!--<label class="mint-switch">
		    		<input type="checkbox" class="mint-switch-input" v-model="inputvalue"> 
		    			<span class="mint-switch-core"></span> 
		    			<div class="mint-switch-label"></div>
		    	</label>-->
		    	<mt-switch v-model="buttonvalue"></mt-switch>
		    </div>
		</div>
		<!--<p>{{flag}}</p>	-->	
    </div>
</template>

<script>
import { Toast } from 'mint-ui';	
import data from '../../../static/json/data2.json'   //导入四级联动省市区数据
var index = 0
var index2 = 0
var index3 = 0
//初始化省-省数组
let province = Object.keys(data)
//console.log(province);
//初始化市
let _y = Object.values(data)

let _m = _y.map(res => {//市数组
return Object.keys(res)
})
//console.log(_m);
let city = _m[index]
//console.log(city);
//初始化区
let _c = Object.values(data)
_c = _c.map(res => {//区数组

return Object.values(res)
})
let __d = Object.values(_c[index])
let area = Object.keys(__d[index])
//console.log(__d);
//初始化街
let __a = Object.values(__d[0])
//console.log(__a);
let street = __a[0]
export default{
//		names: 'index',
		data(){
			return{
				adtitle:'添加新地址',
				//flag:this.$route.query.flag,//从我的地址管理中传过来的标志
				//selecttoMg:this.$route.query.selecttoMg,//实物地址管理点击添加新地址时传过来的标志
                addressids:this.$route.query.editId,   //点击编辑按钮时用路由传过来的地址ID
                selectAd:this.$route.query.label,//实物订单地址选择路由传过来的标志
               // adLength:this.$route.query.adLength,  //点击新增地址时传过来的地址列表长度
                addresslength:localStorage.getItem("addresslength"),
				name: '',          //收货人名字
				phonenum: '',      //收货人电话号码
				buttonvalue:false, //默认地址按钮
		        username:localStorage.getItem("username"),  //用户名
                areaVisible: false,     //所在地区显示隐藏变量
			    streetVisible: false,   //街道显示隐藏变量
			    areaString: '请选择',     //所在地区绑定参数
			    streetString: '请选择',   //街道绑定参数
			    detailedaddress:'',     //详细地址框绑定参数
			      slots: [{             //所在地区地址选择框参数
			        flex: 1,
			        values: province,
			        className: 'slot1',
			        textAlign: 'center'
			      }, {
			        divider: true,
			        content: '-',
			        className: 'slot2'
			      }, {
			        flex: 1,
			        values: city,
			        className: 'slot3',
			        textAlign: 'center'
			      }, {
			        divider: true,
			        content: '-',
			        className: 'slot4'
			      }, {
			        flex: 1,
			        values: area,
			        className: 'slot5',
			        textAlign: 'center'
			      }],
			      slotstree: [{         //街道地址选择框参数
			        flex: 1,
			        values: street,
			        className: 'slot1',
			        textAlign: 'center'
			      }]
					
			}
		},
//		computed:{
//			_m : _y.map(res => {
//			return Object.keys(res)
//			}),
//			city : _m[index],
//			_C : _c.map(res => {
//			return Object.values(res)
//			}),
//			area : Object.keys(__d[index]),
//			street : __a[0]
//		},
		methods:{
			//点击所在地区区域显示函数
     		 handlerArea() {  
		      this.areaVisible = true
		    },
		    
		    //点击所在地区弹框取消按钮函数
		    hidearea(){     
		      this.areaString ='请选择';
		      this.streetString ='请选择';
		      this.areaVisible = false
		    },
		    
		    //点击所在地区弹框确认按钮函数
		    comfirmarea(){  
		      this.areaString =this.areaString1+',';
		      this.areaVisible = false
		    },
		    
		    //点击街道弹框取消按钮函数
		    hidestreet(){    
		      this.streetString ='请选择';
		      this.streetVisible = false
		    },
		    
		    //点击街道弹框确认按钮函数
		    comfirmstreet(){  
		      if(this.areaString=='请选择'){
		      	Toast("请先选择所在地区");
                return false;
		      }else{
		      	this.streetString =this.streetString1+',';
		        this.streetVisible = false;
		        return true;
		      } 
		    },
		    
		    //点击街道区域函数
		    handlerStreet() {   
		      if(this.areaString=='请选择'){
		      	Toast("请先选择所在地区");
		      	this.streetVisible = false
                return false;
		      }else if (this.slotstree[0].values.length === 0) {
		        this.streetString = '请选择'
//		        this.streetString = '无可选街道'
                Toast("请在下方输入该地区街道及详细地址");
		        return
		      }else{
		      	this.streetVisible = true
		      } 
		    },
		    
		    //所在地区弹框地址改变函数
		    onValuesChange(picker, values) {
		    	//console.log(values[0],values[1],values[2]);
		      index = province.indexOf(values[0])
		      index2 = _m[index].indexOf(values[1])
		      //console.log(index);
		      //console.log(index,index2);
		      if (index >= 0) {
		        picker.setSlotValues(1, _m[index])
		      }
		      if (index >= 0 && index2 >= 0) {
		        let __d = Object.values(_c[index])
		        let area = Object.keys(__d[index2])
		        index3 = area.indexOf(values[2])
		        picker.setSlotValues(2, area)
		        this.areaString1 = values.join(',')
		        if (index3 >= 0) {
		          let __a = Object.values(__d[index2])
		          let street = __a[index3]
		          this.slotstree[0].values = street
		        } else {
		          this.$set(this.slotstree[0].values, [])
                  this.streetString = '请选择'
		        }
		      }
		    },
		    
		    //所在街道弹框地址改变函数
		    onStreeChange(picker, values) {
		      this.streetString1 = values.join(',')
//             this.streetString1 = values.join('')
		    },
		    
			//返回函数
			returnback(){  
	          this.$router.back();
	        },
	        
	        //点击保存时触发的函数
	        saveaddress(){
	        	//点击编辑按钮时触发
	        	var streetadd=(this.streetString=='请选择')?(','):(this.streetString);
	        	if(this.addressids){
	        		this.$http.post(this.URL_PREFIX+"/user/saveAddress.net",{phone:this.phonenum,address:this.areaString+streetadd+this.detailedaddress,flag:Number(this.buttonvalue),uid:this.username,name:this.name,id:this.addressids})
				    .then((res) =>{
				  	  if(res.data.code!=200){
				  	  	  Toast(res.data.msg);
				  	  }else{
	                     this.$router.push({path: "/UserCenter/manageAddress"});   
				  	  }
				   });
				//点击底部添加新地址时触发   
	        }else{
	    		   this.$http.post(this.URL_PREFIX+"/user/saveAddress.net",{phone:this.phonenum,address:this.areaString+streetadd+this.detailedaddress,flag:Number(this.buttonvalue),uid:this.username,name:this.name})
				    .then((res) =>{
				  	  if(res.data.code!=200){
				  	  	  Toast(res.data.msg);
				  	  }else if(this.selectAd=='selectAd'){ //保存时判断回到地址管理还是地址选择
	                     this.$router.push({path: "/UserCenter/selectAddress"});   
				  	  }else{
				  	  	this.$router.push("/UserCenter/manageAddress");  
				  	  }
				   });
	           }
	        }, 
	        
            //点击保存按钮时的正则判断
	        toselectAddress(){
	        	var regname =this.name.length;
	        	var regphone=/^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
	        	var regtext=this.detailedaddress.length;
	        	if((this.name=='')&&(this.phonenum=='')&&(this.areaString=='请选择')&&(this.detailedaddress=='')){
	        		Toast("输入信息不能为空！");
	        	}else if(regname<2||regname>10){
	        		Toast("收货人名字在2~10个字之间");
	        	}else if((this.phonenum=='')||(!regphone.test(this.phonenum))){
	        		Toast("手机号码格式错误");
	        	}else if(this.areaString=='请选择'){
	        		Toast("请选择所在地区");
	        	}else if(this.detailedaddress==''||regtext<5){
	        		Toast("详细地址至少5个字");
	        	}else if(this.addresslength>=20){
	        		//console.log(this.addressLength);
	        		Toast('该用户收货地址已满');
	        	}else{
	        		this.saveaddress();
	        	}
	        },
//	        toselectAddress(){
//	        	var regname =/^\S{2,10}$/;
//	        	var regphone=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
//	        	var regtext=/^.{5,100}$ /;
//	        	if((this.name=='')&&(this.phonenum=='')&&(this.areaString=='请选择')&&(this.detailedaddress=='')){
//	        		Toast("输入信息不能为空！");
//	        		return;
//	        	};
//	        	if(this.name=='')
//	        },
	        
            //地址管理页面点击编辑时页面取值
            editaddres(){
            	this.adtitle='修改地址';
	    		this.$http.post(this.URL_PREFIX+"/user/findAddressById.net",{id:this.addressids})
			  	  .then((res) =>{
//			  	  	console.log(res);
			  	   this.name=res.data.obj.name;               //用户名
			  	   this.phonenum=res.data.obj.phone;          //电话号码     
			  	   this.buttonvalue=res.data.obj.flag==1;        //默认选项按钮
                   var arr=res.data.obj.address.split(',');   //地址切割处理
                   this.areaString=arr[0] + ',' + arr[1] + ',' +arr[2] + ',';   //所在地区
                   if(arr[3]==''){
                   	this.streetString='请选择';       //街道
                   }else{
                   	this.streetString=arr[3] + ',';       //街道
                   };
                   this.detailedaddress=arr[4];    //详细地址
//                 console.log(res.data.obj.flag);
//                 console.log(res.data.obj.flag==1);
			  	  });
	    		},
	    	},
			created(){
				if(this.addressids){
					this.editaddres();
				}
		    }
		    	
            //街道地址切割处理函数
//          addresscat(str){
//          	var arr = str.split(',');
//          	var res =arr[0] + ',' + arr[1] + ',' +arr[2];
//          	return res;
//          },
	        //手机号验证
//	     	validatePhone(){
//	     		var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
//	     		if(this.phone==''){
//                  Toast("请输入手机号码");
//                 return false;
//              }else if(!reg.test(this.phone)){
//                  Toast("手机号格式不正确");
//                  return false;
//              }else{
//              	return true;
//              }
//	     	},
		
}
</script>

<style scoped="scoped">
#addAddress{
	color: #666666;
}
 .aAtextarea{
 	width: 100%;
 	min-height: 115px;
 	border: 0;
 }
 .aAddresstextarea{
 	padding: 5px 15px 0 15px;
 	background: #FFFFFF;
 }
 
 .mint-switch {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
}

.mint-switch-input {
    display: none;
}

.mint-switch-input:checked + .mint-switch-core {
    border-color: #26a2ff;
    background-color: #26a2ff;
}
.mint-switch-core {
    display: inline-block;
    position: relative;
    width: 52px;
    height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 16px;
    box-sizing: border-box;
    background: #d9d9d9;
}
.mint-switch-input:checked + .mint-switch-core::before {
    -webkit-transform: scale(0);
    transform: scale(0);
}

.mint-switch-core::before {
    width: 50px;
    height: 30px;
    background-color: #fdfdfd;
}

.mint-switch-core::after, .mint-switch-core::before {
    content: " ";
    top: 0;
    left: 0;
    position: absolute;
    -webkit-transition: -webkit-transform .3s;
    transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    border-radius: 15px;
}

.mint-switch-input:checked + .mint-switch-core::after {
    -webkit-transform: translateX(20px);
    transform: translateX(20px);
}

.mint-switch-core::after {
    width: 30px;
    height: 30px;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .4);
}

.mint-switch-core::after, .mint-switch-core::before {
    content: " ";
    top: 0;
    left: 0;
    position: absolute;
    -webkit-transition: -webkit-transform .3s;
    transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    border-radius: 15px;
}
#addAddress .addAddressmain input::-ms-input-placeholder{text-align: right;} 
#addAddress .addAddressmain input::-webkit-input-placeholder{text-align: right;}

</style>


// WEBPACK FOOTER //
// src/views/UserCenter/addAddress.vue